module.exports = __webpack_public_path__ + "img/T1D_xh3.6f10ee5a.png";